import React, { useState } from 'react';
import AdTypeStep from '../steps/AdTypeStep'; // Step 1
import GeoStep from '../steps/GeoStep'; // Step 2
import TargetingStep from '../steps/TargetingStep'; // Step 3
import QualityStep from '../steps/QualityStep'; // Step 4
import BidStep from '../steps/BidStep'; // Step 5
import CreativeStep from '../steps/CreativeStep'; // Step 6
import BudgetStep from '../steps/BudgetStep'; // Step 7
import AdvancedSettingsStep from '../steps/AdvancedSettingsStep'; // Optional Advanced Settings
import NavigationButton from '../component/NavigationButton';
import './AdTypeComponent.css';

// Define the initial form data structure
const initialFormData = {
  adFormat: '',  // Added field for ad format
  campaignName: '',
  bid: '',
  geo: '',
  bidRequests: '',
  videoImp: '',
  visits: '',
  winRate: '',
  cost: '',
  dailyCap: '',
  name: '',
  code: '',
  adName: '',
  title: '',
  description1: '',
  description2: '',
  displayURL: '',
  destinationURL: '',
  trafficSourceType: '',
  frequencyFilter: '',
  impressions: '',
  clicks: '',
  conversions: '',
  budget: '',
  targetingOptions: '',
  qualityScore: '',
  noDailyLimit: '',
  imgLocation: '',
  imgurl:''
};

// Define steps for the form
const steps = [
  { label: 'Ad Type', active: true },
  { label: 'GEO', active: false },
  { label: 'Targeting', active: false },
  { label: 'Quality', active: false },
  { label: 'Bid', active: false },
  { label: 'Creative', active: false },
  { label: 'Budget', active: false }
];

const MultiStepForm: React.FC = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle form field changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle step changes
  const handleStepChange = (stepIndex: number) => {
    setStep(stepIndex);
  };

  // Move to the next step
  const handleNext = () => {
    if (step < 7) {
      setStep(step + 1);
    }
  };

  // Handle going back to the previous step
  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      console.log("Submitting form data:", formData); // Log form data before sending
      const baseUrl =
      window.location.hostname === 'localhost'
        ? `http://localhost:5000/api/campaigns/saveCampaign`
        : `https://bidvertiser-api.vercel.app/api/campaigns/saveCampaign`;

    // const response = await fetch(baseUrl);


      const response = await fetch("https://bidvertiser-api.vercel.app/api/campaigns/saveCampaign", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      console.log("Response Status:", response.status); // Log status

      let data;
      try {
        data = await response.json();
        console.log("Response Data:", data); // Log actual response data
      } catch (jsonError) {
        console.error("Failed to parse JSON response:", jsonError);
        alert('Unexpected server response.');
        return;
      }

      if (response.ok) {
        alert('Campaign saved successfully!');
        setStep(1); // Reset to the first step
        setFormData(initialFormData); // Reset form data
      } else {
        alert(`Error: ${data.message || 'Failed to save campaign'}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while saving the campaign.');
    } finally {
      setIsSubmitting(false);
    }
};

  return (
    <div className="MainSection">
      {/* Navigation Steps */}
      <div
        className="form-buttons-container"
        style={{
          display: 'flex',
          gap: '10px',
          fontSize: '12px',
          width: '900px',
          border: 'solid',
          cursor: 'pointer',
          borderWidth: '0px 0px 0.1px 0px',
          color: 'gray',
        }}>
        {steps.map((stepInfo, index) => (
          <div
            className="step-wrapper"
            key={index}
            onClick={() => handleStepChange(index + 1)}
          >
            <div  className={`step ${step === index + 1 ? 'active' : ''} ad-type-container`}>
              <span className="step-label" style={{ cursor: 'pointer', userSelect: 'none' }}>
                {stepInfo.label}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Form Steps */}
      <div>
        {step === 1 && (
          <div>
          {step === 1 && <AdTypeStep handleInputChange={handleInputChange} formData={formData} />}

          </div>
        )}
        {step === 2 && <GeoStep handleInputChange={handleInputChange} formData={formData} />}
        {step === 3 && <TargetingStep handleInputChange={handleInputChange} formData={formData} />}
        {step === 4 && <QualityStep handleInputChange={handleInputChange} formData={formData} />}
        {step === 5 && <BidStep handleInputChange={handleInputChange} formData={formData} />}
        {step === 6 && <CreativeStep handleInputChange={handleInputChange} formData={formData} setFormData={setFormData}  />}
        {step === 7 && <BudgetStep handleInputChange={handleInputChange} formData={formData} />}
      </div>

      {/* Navigation and Submit Buttons */}
      <NavigationButton
        step={step}
        steps={7}
        handleNext={handleNext}
        handleBack={handleBack}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default MultiStepForm;
